// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KZZH","question":"styles_question__1nmaE","inputVisibleButton":"styles_inputVisibleButton__11Tve","note":"styles_note__1ZHev"};